import type { MenuItemId } from '../types';

export interface TrayItem {
  customerId: number;
  item: MenuItemId;
}

export class TraySystem {
  readonly items: TrayItem[] = [];

  constructor(readonly capacity = 2) {}

  get isFull(): boolean {
    return this.items.length >= this.capacity;
  }

  add(item: TrayItem): boolean {
    if (this.isFull) return false;
    this.items.push(item);
    return true;
  }

  takeForCustomer(customerId: number): TrayItem | undefined {
    const index = this.items.findIndex((item) => item.customerId === customerId);
    if (index < 0) return undefined;
    return this.items.splice(index, 1)[0];
  }

  takeAllForCustomer(customerId: number): TrayItem[] {
    const items = this.items.filter((item) => item.customerId === customerId);
    for (let index = this.items.length - 1; index >= 0; index -= 1) {
      if (this.items[index].customerId === customerId) this.items.splice(index, 1);
    }
    return items;
  }

  countForCustomer(customerId: number): number {
    return this.items.filter((item) => item.customerId === customerId).length;
  }

  clear(): void {
    this.items.length = 0;
  }
}
